<template>
  <div>
    <div class="bannerWrap">
      <swiper :options="swiperOption1"
              ref="mySwiper">
        <swiper-slide v-for="(item,index) in apiData.bannerimg"
                      :key="index">
          <div class="bannerBgWrap text_center">
            <div class="btnbanner">
              <img :src="item"
                   class="marginRight10 imgvertical-3">
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination"
             slot="pagination"></div>
      </swiper>
      <div class="menuBlock">
        <div class="ac_block ac_block_active ">
          <img src="/image/quanke/tagmenu.png"
               class="activeImg">
          <img src="/image/quanke/tagmenu.png"
               class="normalimg">
          <p>专家精讲</p>
        </div>
        <div class="ac_block">
          <img src="/image/quanke/tagmenu.png"
               class="activeImg">
          <img src="/image/quanke/useimg2.png"
               class="normalimg">
          <p>精品课程</p>
        </div>
        <div class="ac_block">
          <img src="/image/quanke/tagmenu.png"
               class="activeImg">
          <img src="/image/quanke/useimg3.png"
               class="normalimg">
          <p>国际课程</p>
        </div>
        <div class="ac_block">
          <img src="/image/quanke/tagmenu.png"
               class="activeImg">
          <img src="/image/quanke/useimg4.png"
               class="normalimg">
          <p>科研课程</p>
        </div>
        <div class="ac_block">
          <img src="/image/quanke/tagmenu.png"
               class="activeImg">
          <img src="/image/quanke/useimg5.png"
               class="normalimg">
          <p>技能技术</p>
        </div>
        <div class="ac_block">
          <img src="/image/quanke/tagmenu.png"
               class="activeImg">
          <img src="/image/quanke/useimg6.png"
               class="normalimg">
          <p>指南解读</p>
        </div>
        <div class="ac_block">
          <img src="/image/quanke/tagmenu.png"
               class="activeImg">
          <img src="/image/quanke/useimg7.png"
               class="normalimg">
          <p>国医课堂</p>
        </div>
        <div class="ac_block">
          <img src="/image/quanke/tagmenu.png"
               class="activeImg">
          <img src="/image/quanke/useimg8.png"
               class="normalimg">
          <p>临床案例</p>
        </div>
      </div>
    </div>
    <div class="EC_width">
      <div class="gl_title_bar marginTop40">
        <div class="gl_tb_left">
          <span class="normaltitle">课程推荐</span>
          <a href="javascript:;"
             class="gl_pad_btn gl_pad_btn_active marginLeft10">全部</a>
          <a href="javascript:;"
             class="gl_pad_btn marginLeft10">单课程</a>
          <a href="javascript:;"
             class="gl_pad_btn marginLeft10">专栏</a>
          <a href="javascript:;"
             class="gl_pad_btn marginLeft10">大专栏</a>
        </div>
        <div class="gl_tb_right">
          <a href="javascript:;"
             class="gl_tb_right_more"><img src="/image/index/moreimg.png"
                 class="gltb_moreimg">更多课程</a>
        </div>
      </div>
      <div class="display_between marginTop20"
           v-for="(item,index) in uselist"
           :key="index">
        <div class="pub_square"
             v-for="(itemn,indexn) in item"
             :key="indexn">
          <div class="pubs_img">
            <img :src="itemn.img">
          </div>
          <div class="pubs_body">
            <div class="pubs_title">
              {{itemn.title}}
            </div>
            <div class="pubs_label display_between">
              <div>
                <span v-for="(itemX,indexX) in itemn.sign"
                      :key="indexX">{{itemX}}</span>
              </div>
              <div class="pubs_cancel">
                取消收藏
              </div>
            </div>
            <div class="display_between">
              <div class="pubs_tip">
                <span class="redColor">{{itemn.price}}</span>
              </div>
              <div class="pubs_rentou">
                <img src="/image/geren/ren.png">{{itemn.num}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text_center marginTop50 marginBottom50">
        <img src="/image/quanke/bannercenter.png">
      </div>
      <div class="display_flex">
        <div class="flex1">
          <div class="gl_title_bar">
            <div class="gl_tb_left">
              <span class="normaltitle">项目专题</span>
              <a href="javascript:;"
                 class="gl_pad_btn gl_pad_btn_active marginLeft10">社区连线</a>
              <a href="javascript:;"
                 class="gl_pad_btn marginLeft10">基层连线</a>
            </div>
          </div>

          <div class="gl_listWrapBar"
               v-for="(item,index) in apiData.project"
               :key="index">
            <div class="gl_imgList">
              <img :src="item.img">
            </div>
            <a href="#"
               class="gl_listItem display_column_between">
              <div class="gl_listItemTitle">
                {{item.title}}
              </div>

              <div class="display_between marginTop10">
                <div>
                  <span class="gl_gree_block"
                        v-for="(itemn,indexn) in item.sign"
                        :key="indexn">{{itemn}}</span>
                </div>
                <div class="gl_inforshow">
                  <span class="marginRight20">{{item.date}}</span>
                  <span><img src="/image/index/chakan.png">{{item.browse}}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="marginLeft50">
          <p class="marginTop10"><img src="/image/quanke/rightImg1.png"></p>
          <p class="marginTop10"><img src="/image/quanke/rightImg2.png"></p>
          <p class="marginTop10"><img src="/image/quanke/rightImg3.png"></p>
          <p class="marginTop10"><img src="/image/quanke/rightImg4.png"></p>
        </div>
      </div>
      <div class="display_between">
        <div class="footerBlock">
          <p class="bigTitle">1998 <span>年</span></p>
          <p class="normaltext">杂志社成立于1998年</p>
        </div>
        <div class="footerBlock">
          <p class="bigTitle">300 <span>+</span></p>
          <p class="normaltext">拥有视频的总数量</p>
        </div>
        <div class="footerBlock">
          <p class="bigTitle">600 <span>+</span></p>
          <p class="normaltext">视频时长的总分钟数</p>
        </div>
        <div class="footerBlock">
          <p class="bigTitle">300 <span>+</span></p>
          <p class="normaltext">参与培训的专家人数</p>
        </div>
        <div class="footerBlock">
          <p class="bigTitle">23 <span>+</span></p>
          <p class="normaltext">至今已有23年的历史</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from "lodash"
export default {
  name: "home",
  data () {
    return {
      apiData: {},
      uselist: [],
      swiperOption1
        :
      {
        loop: true, // 循环模式选项
        // 如果需要分页器
        pagination
          :
        {
          el: '.swiper-pagination',
          bulletClass
            :
            'bulletWrite',
          bulletActiveClass
            :
            'bulletWriteActive',
        }
        ,
      }
      ,
    }
  },
  created () {
    this.getData()

  },
  methods: {
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        var usedata = data.qkHome.course;
        that.uselist = lodash.chunk(usedata, 4);
        that.apiData = data.qkHome
      })
    },
  }
}
</script>

<style scoped>
/* 轮播 */
.bulletWrite {
    margin-right: 6px;
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #6c9ca3;
    border-radius: 50%;
}

.bulletWriteActive {
    width: 24px;
    height: 10px;
    background: #ffffff;
    border-radius: 4px;
    opacity: 1;
}

.my-bullet-active {
    background: #ff6600;
    opacity: 1;
}

.swiper-pagination {
    text-align: left;
    box-sizing: border-box;
    padding-left: 360px;
    bottom: 137px !important;
}

.bannerWrap {
    position: relative;
}

.menuBlock {
    width: 1200px;
    height: 110px;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.06);
    border-radius: 6px 6px 0px 0px;
    margin: 0 auto;
    position: absolute;
    bottom: 0px;
    background: #fff;
    z-index: 10;
    left: 360px;
    display: flex;
}

.activeImg {
    display: none;
}

.ac_block {
    flex: 1;
    color: #333;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
}

.ac_block img {
    margin-top: 20px;
}

.ac_block p {
    margin-top: 10px;
}

.ac_block_active {
    background: #ff7e00;
    color: #fff;
}

.ac_block_active .activeImg {
    display: inline-block;
}

.ac_block_active .normalimg {
    display: none;
}

.footerBlock {
    padding: 60px 0;
    text-align: center;
}

.bigTitle {
    font-size: 50px;
    font-family: Minion Pro;
    font-weight: bold;
    color: #000000;
}

.bigTitle span {
    vertical-align: top;
    font-size: 14px;
    font-weight: bold;
}

.normaltext {
    font-size: 16px;
}
</style>
